import { tv } from '~/utils/tv'

export const paginationItemVariants = tv({
  base: 'flex p-none',
  variants: {
    hasCurrent: {
      false: 'max-sm:hidden',
    },
  },
  defaultVariants: {
    hasCurrent: false,
  },
})
